module.exports = __webpack_public_path__ + "static/media/bgheroprovideright.c744ed46.webp";